import EventListingPrimaryView from './../EventListingPrimaryView';
import EventListingViewMode from './../EventListingViewMode';
import EventsCalendarViewMode from './EventsCalendarViewMode';
import TabNav from '../ui/TabNav';
import DataStore from '../api/DataStore';
import CalendarMonthView from './CalendarMonthView';
import CalendarWeekView from './CalendarWeekView';
import CalendarDayView from './CalendarDayView';
import { getISODateString } from './../date/DateHelpers';

function transform(data) {
  const perfsByDate = new Map();

  data.productions.forEach((production) => {
    production.performances.forEach((performance) => {
      const key = getISODateString(performance.iso8601Date);
      const otherDayPerfs = perfsByDate.get(key) || [];

      otherDayPerfs.push(performance);
      perfsByDate.set(key, otherDayPerfs);
    });
  });

  perfsByDate.forEach((perfs) => {
    perfs.sort((a, b) => a.iso8601Date.getTime() - b.iso8601Date.getTime());
  });

  const sortedPerfsByDate = new Map();

  Array.from(perfsByDate.keys()).sort().forEach((key) => {
    sortedPerfsByDate.set(key, perfsByDate.get(key));
  });

  return sortedPerfsByDate;
}


class EventsCalendarView extends EventListingPrimaryView {
  constructor(config, keywordFilter, viewToggle) {
    super(config, keywordFilter, viewToggle);

    this.store = new DataStore(transform);

    this.store.on('date', () => {
      if (this.isVisible) {
        this.fetchData();
      }
    });

    this.childViews = {
      [EventsCalendarViewMode.MONTH]: new CalendarMonthView(this.store, config),
      [EventsCalendarViewMode.WEEK]: new CalendarWeekView(this.store, config),
      [EventsCalendarViewMode.DAY]: new CalendarDayView(this.store, config),
    };

    const mode = config.calendarViewMode;

    this.tabNav = new TabNav('#tn-events-calendar-mode-tab-nav', {
      mode,
      activeClass: 'active',
      onChange: this.setMode.bind(this),
    });

    this.setMode(mode);
  }

  setMode(mode) {
    if (mode !== this.mode) {
      this.mode = mode;
      this.store.emit('mode', { mode });
    }
  }

  getCurrentView() {
    return this.childViews[this.mode];
  }

}

EventsCalendarView.ViewMode = EventListingViewMode.CALENDAR;

export default EventsCalendarView;



// WEBPACK FOOTER //
// ./V7/events/listing/calendarView/EventsCalendarView.js